const airline = {
    getlist: 'airline/getlist',
    add: 'airline/add',
    update: 'airline/update',
    remove: 'airline/remove',
    get: 'airline/get',
    getall: 'airline/getall',
    clearcache: 'airline/clear-cache',
}
export default airline
